import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lineLabel", "linePrice", "totalAmount"]
  static values = {
    pricePerItemCents: Number
  }

  declare hasLineLabelTarget: boolean
  declare lineLabelTarget: HTMLElement
  declare hasLinePriceTarget: boolean
  declare linePriceTarget: HTMLElement
  declare hasTotalAmountTarget: boolean
  declare totalAmountTarget: HTMLElement
  declare pricePerItemCentsValue: number

  updateFromQuantity(event: CustomEvent) {
    const detail = event.detail || {}
    const quantity = Number(detail.quantity)
    const totalFormatted = detail.totalFormatted
    const lineLabel = detail.lineLabel
    const linePriceFormatted = detail.linePriceFormatted
    const pricePerItemCents = detail.pricePerItemCents

    if (this.hasLineLabelTarget) {
      if (typeof lineLabel === 'string' && lineLabel.length > 0) {
        this.lineLabelTarget.textContent = lineLabel
      } else if (pricePerItemCents && Number.isFinite(quantity)) {
        const plural = quantity > 1 ? 's' : ''
        this.lineLabelTarget.textContent = `${quantity} Reminder${plural}`
      }
    }

    if (this.hasLinePriceTarget) {
      if (typeof linePriceFormatted === 'string' && linePriceFormatted.length > 0) {
        this.linePriceTarget.textContent = linePriceFormatted
      } else {
        const priceCents = pricePerItemCents || this.pricePerItemCentsValue
        if (priceCents) {
          this.linePriceTarget.textContent = `$${(priceCents / 100).toFixed(2)} each`
        }
      }
    }

    if (this.hasTotalAmountTarget && totalFormatted) {
      this.totalAmountTarget.textContent = `$${totalFormatted}`
    }
  }
}
